module.exports = __webpack_public_path__ + "static/media/footerLogo.0a8b82ab.jpeg";